// extracted by mini-css-extract-plugin
module.exports = {"sideList":"sideNav_sideList__1vzQ4","listItem":"sideNav_listItem__3ZIuU","link":"sideNav_link__rhWns"};